import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=33447fd2&scoped=true&"
import script from "./Zonas.vue?vue&type=script&lang=js&"
export * from "./Zonas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33447fd2",
  null
  
)

export default component.exports